import * as React from 'react';
import { useState } from 'react';
import {
    clearHoveredTranslation,
    highlightHoveredTranslation,
    translationTargetAt
} from './renderedTranslations';

export type HoveredTranslationKey = {
    key: string;
    x: number;
    y: number;
};

export function useTranslationKeyHover() {
    const [hovered, setHovered] = useState<HoveredTranslationKey | null>(null);

    function handleMouseOverCapture(event: React.MouseEvent<HTMLElement>) {
        const target = translationTargetAt(event.target);
        if (target === null) {
            clearHoveredTranslation();
            setHovered(null);
            return;
        }
        highlightHoveredTranslation(target.element);
        setHovered({ key: target.key, x: event.clientX, y: event.clientY });
    }

    function handleMouseLeave() {
        clearHoveredTranslation();
        setHovered(null);
    }

    return { hovered, handleMouseOverCapture, handleMouseLeave };
}
